import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-zinc-950 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-123" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-124" data-mp="1dxjhbbtfivbz">
        <SectionHeading id="modules-title" data-id="element-125" data-mp="1dunill9rc2mh">The {totalVolumes} <span className="text-orange-400" data-id="element-126" data-mp="2bj7fo29g3nq5">Complete Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-127" data-mp="26km9lm7ii9ts">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-teal-700/70 bg-zinc-900 p-6 shadow-lg shadow-black/30" data-id="element-128" data-mp="21nvxtb2qq0e6" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-129" data-mp="1ns8wq7w6kvv2">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-teal-400/40 bg-zinc-950 text-teal-400" data-id="element-130" data-mp="18w154mig0s5r">
                    <Icon className="h-5 w-5 drop-shadow-[0_0_6px_rgba(45,212,191,0.55)]" aria-hidden="true" data-id="element-131" data-mp="1dxyrhpm5432x" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-orange-400" data-id="element-132" data-mp="14vpjb6ecglsp">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-white" data-id="element-133" data-mp="q8e8x7twf7u6">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-300" data-id="element-134" data-mp="v3bfm83ph53w">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}